export default {
  getDriedAbaloneSummary: (state) => state.driedAbaloneSummary,
};
